export default class TextHelper {
    static lowerCaseFirstLetter(text: string) {
        return text.charAt(0).toLowerCase() + text.slice(1);
    }

    static limit(text: string, length: number, suspension: string = "...") {
        if (text.length === 0 || text.length < length){
            return text;
        }

        if (text.lastIndexOf(" ", length) != -1)
        {
            return text.substring(0, text.lastIndexOf(" ", length)) + suspension;
        }
        else
        {
            return text.substring(0, length) + suspension;
        }
    }
}